import { render, staticRenderFns } from "./FilterProduct.vue?vue&type=template&id=52469c70&scoped=true&"
import script from "./FilterProduct.vue?vue&type=script&lang=js&"
export * from "./FilterProduct.vue?vue&type=script&lang=js&"
import style0 from "./FilterProduct.vue?vue&type=style&index=0&id=52469c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52469c70",
  null
  
)

export default component.exports